import { createFileRoute } from '@tanstack/react-router';

import { loadDataprevEmployeeMessages, loadDataprevEmployeeScreens, warrantyExecutionScreen, warrantyExecutionSearch } from '@/modules/dataprev-employee/route';
import { lazyScreen } from '@/shared/screen';

// Execução de garantias no caminho do legado (`router.tsx:1450-1458`), com NaturalPerson:AuctionQuery
// estrito. Arquivo leve (JS inicial); a tela vem em chunk próprio.
export const Route = createFileRoute('/_app/gestao-carteira/execucao-garantias/')({
  validateSearch: warrantyExecutionSearch,
  staticData: { screen: warrantyExecutionScreen },
  loader: () => loadDataprevEmployeeMessages(),
  component: lazyScreen(loadDataprevEmployeeScreens, 'WarrantyExecutionRouteScreen'),
});
